type SplitText = {
  before: string;
  keyword: string;
  after: string;
};

/**
 * テキストをキーワードで前・キーワード・それ以降の3つに分ける
 * キーワードが複数回含まれても最初の1回だけを対象にする
 * 見つからない場合は before に全文が入り、keyword と after は空になる
 * @param text 分割するテキスト
 * @param keyword 区切りにするキーワード
 */
export const splitText = (text: string, keyword: string | null): SplitText => {
  const index = keyword ? text.indexOf(keyword) : -1;

  if (!keyword || index === -1) {
    return { before: text, keyword: '', after: '' };
  }

  return {
    before: text.slice(0, index),
    keyword,
    after: text.slice(index + keyword.length),
  };
};
